import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  filterChip: {
    textTransform: "none !important",
    borderRadius: "100px !important",
    padding: "6px 12px !important",
    fontSize: "13px !important",
    border: "1px solid #606479 !important",
    color: "#B1B5C9 !important",
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: "#252A38 !important",
    },
  },
  filterChipActive: {
    backgroundColor: "#252A38 !important",
    borderColor: "#6C65D9 !important",
  },
  attachButton: {
    textTransform: "none !important",
    borderRadius: "5px !important",
    padding: "6px 12px !important",
    fontSize: "13px !important",
    color: "#B1B5C9 !important",
    border: "1px dashed #B1B5C9 !important",
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.04) !important",
      borderColor: "#6C65D9 !important",
    },
  },
}));

export default useStyles;
